import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Error extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
    }

    _renderText(item) {
        return langRegister.get("error", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"error"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang())} className={Styles.button}>
                        {this._renderText("item_3")}
                    </div>
                </div>
            </div>
        );
    }
}

export default Error;


// WEBPACK FOOTER //
// ./src/pages/error/component.js